import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

import classes from './targetMarketPlan.module.scss';

import TMSDataTableLoadingSkeleton from './components/TMSDataTableLoadingSkeleton';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import SummaryModal from './components/SummaryModal';

import { useTargetMarketShate } from './useTargetMarketShare';
import { InputSwitch } from 'primereact/inputswitch';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { salesPlanAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import CopyIcon from 'assets/icons/copyIcon.svg';
import ResetIcon from 'assets/icons/revertIcon.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

const TargetMarketPlanEdit = ({ next }: { next: () => void }) => {
  const {
    userModulesRoles,
    conceptDetails,
    contractDetails,
    tmsPlanningMonth,
    confirmVisibility,
    summaryVisibility,
    isDirect,
    directCOT,
    indirectCOT,
    setIndirectCOT,
    setIsdirect,
    isDirectFinish,
    setIsDirectFinish,
    isSalesDetailsLoading,
    istmsPlanDataDirectLoading,
    singleConfirmVisibility,
    isConceptLoading,
    isConceptDetailsLoading,
    isTMSNotesDataLoading,
    tmsEditData,
    isTMSPlanViewDataLoading,
    istmsUpdateLoading,
    savingSingle,
    savingCategory,
    confirmPopup,
    finishPopup,
    finishConfirmVisibility,
    copyRowinfo,
    setFinishConfirmVisibility,
    setFinishPopup,
    singleconfirmPopup,
    isMSplanNoteSaving,
    tmsNotesData,
    setSingleconfirmPopup,
    setConfirmPopup,
    handleNavigateToViewScreen,
    setConfirmVisibility,
    setSummaryVisibility,
    getValues,
    getIsDeramped,
    updateMSPlanValue,
    getSalesSummaryVal,
    setDirectCOT,
    setSingleConfirmVisibility,
    isOldValueCheckBoxVisible,
    isOldValuesCheckBoxChecked,
    toggleOldValuesChekedSwitch,
    handleSaveSingleCOTMSplan,
    handleSaveAllCOTMSplan,
    handleFinishforCategory,
    handleNoteAdd,
    handleCopyButtonClick,
    handleResetButtonClick,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    isNoteEdited,
    isNoteDeleted,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
    directFocused,
    indirectFocused,
    directInputFocus,
    indirectInputFocus,
  } = useTargetMarketShate();

  return (
    <div className={classes.targetMarketContainer}>
      <div className={classes.planningContainer}>
        <div className={classes.tmsHeading}>
          <h2>Market Share Planing</h2>
        </div>
        {isConceptDetailsLoading || isConceptLoading ? (
          <ConceptDetailsSkeleton />
        ) : (
          <ConceptDetailsSection
            conceptDetails={conceptDetails}
            contractDetails={contractDetails}
            mode="add"
          />
        )}
      </div>
      <div style={{ display: 'flex', gap: '1rem' }}>
        {/* plan container start */}
        <div style={{ width: '90rem', flexGrow: '1' }}>
          {istmsPlanDataDirectLoading ||
          isConceptDetailsLoading ||
          isConceptLoading ||
          isTMSPlanViewDataLoading ? (
            <TMSDataTableLoadingSkeleton />
          ) : !istmsPlanDataDirectLoading && tmsEditData.length !== 0 ? (
            <div className={classes.planDetailsContainer}>
              <h4 style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>
                  Plan {tmsPlanningMonth[0].label} - {tmsPlanningMonth[14].label}{' '}
                  <span style={{ color: 'green' }}>*</span>
                </span>
              </h4>
              {/* Direct Container start */}
              <div
                style={{
                  marginLeft: '0.5rem',
                  marginRight: '0.5rem',
                  marginTop: '0.5rem',
                }}
              >
                <Accordion className={classes.accordianComponent} activeIndex={0}>
                  <AccordionTab header="Direct" className={classes.accordianTabComponent}>
                    <div className={classes.directContainer}>
                      <div className={classes.topHeader}>
                        <div className={classes.saleDetails}>
                          <div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              YTD:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, 'YTD', 'direct')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                            <div className={classes.vertical}></div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              3MA:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, '3MA', 'direct')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                            <div className={classes.vertical}></div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              PM:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, 'PM', 'direct')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className={classes.directRadioGrp}>
                          <div>
                            <input
                              type="radio"
                              name="directRadio"
                              checked={directCOT.label === 'CMOP'}
                              onClick={() => {
                                setDirectCOT(() => ({
                                  label: 'CMOP',
                                  value: 'CMOP',
                                }));
                              }}
                            />
                            <label htmlFor="cmop">CMOP</label>
                          </div>
                          <span>
                            <input
                              type="radio"
                              name="directRadio"
                              checked={directCOT.label === 'VA Facility'}
                              onClick={() => {
                                setDirectCOT(() => ({
                                  label: 'VA Facility',
                                  value: 'VA Facility',
                                }));
                              }}
                            />
                            <label htmlFor="va">VA Facility</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="directRadio"
                              checked={directCOT.label === 'TMOP'}
                              onClick={() => {
                                setDirectCOT(() => ({
                                  label: 'TMOP',
                                  value: 'TMOP',
                                }));
                              }}
                            />
                            <label htmlFor="tmop">TMOP</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="directRadio"
                              checked={directCOT.label === 'MTF'}
                              onClick={() => {
                                setDirectCOT(() => ({
                                  label: 'MTF',
                                  value: 'MTF',
                                }));
                              }}
                            />
                            <label htmlFor="mtf">MTF</label>
                          </span>
                        </div>
                        <div>
                          {isOldValueCheckBoxVisible(directCOT.value, true) && (
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                paddingRight: '8px',
                                fontSize: '1rem',
                                gap: '1rem',
                              }}
                            >
                              New values
                              <InputSwitch
                                checked={isOldValuesCheckBoxChecked(true, directCOT.value)}
                                onChange={() => toggleOldValuesChekedSwitch(directCOT.value, true)}
                              />
                              Old values
                            </span>
                          )}
                        </div>
                      </div>

                      <div>
                        <div className={classes.planTable}>
                          <table>
                            <thead>
                              <th>
                                <td>Planning Period</td>
                              </th>
                              <th>
                                <td>Strat Code</td>
                              </th>
                              <th>
                                <td>TMS</td>
                              </th>
                              <th>
                                <td
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <span>MS Plan</span>
                                </td>
                              </th>
                              <th>
                                <td></td>
                              </th>
                            </thead>
                            <tbody>
                              {tmsPlanningMonth.map((_, idx) => {
                                const derampTitle = getIsDeramped(directCOT.value, tmsPlanningMonth[idx].dateString, 'direct')
                                  ? `NC De-ramp applied — contract term date: ${tmsPlanningMonth[idx].dateString}`
                                  : undefined;
                                return (
                                  <tr
                                    key={idx}
                                    title={derampTitle}
                                    style={{
                                      backgroundColor: `${directFocused === idx ? '#f7f3fe' : ''}`,
                                    }}
                                  >
                                    <td>{tmsPlanningMonth[idx].label}</td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {getValues(
                                        directCOT.value,
                                        tmsPlanningMonth[idx].dateString,
                                        'direct',
                                        'stratCode'
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {getValues(
                                        directCOT.value,
                                        tmsPlanningMonth[idx].dateString,
                                        'direct',
                                        'tmsval'
                                      )}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      <div className={classes.msPlanInputContainer}>
                                        <input
                                          id={`direct-input-box-${idx}`}
                                          className={classes.msplanInp}
                                          value={getValues(
                                            directCOT.value,
                                            tmsPlanningMonth[idx].dateString,
                                            'direct',
                                            'msplan'
                                          )}
                                          onChange={e => {
                                            updateMSPlanValue(
                                              e.target.value,
                                              directCOT.value,
                                              tmsPlanningMonth[idx].dateString,
                                              'direct'
                                            );
                                          }}
                                          ref={(el: HTMLInputElement) =>
                                            (directInputFocus.current[idx] = el)
                                          }
                                          onKeyDown={e => handleDirectKeyPress(e, idx)}
                                          onFocus={() => {
                                            handleDirectFocus(idx);
                                          }}
                                          onBlur={() => {
                                            handleDirectBlur();
                                          }}
                                        />{' '}
                                        <span> %</span>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <Button
                                          style={{
                                            height: '28px',
                                            width: '28px',
                                          }}
                                          icon={
                                            <img
                                              src={CopyIcon}
                                              style={{
                                                height: '20px',
                                                width: '20px',
                                                cursor: 'pointer',
                                                opacity:
                                                  getValues(
                                                    directCOT.value,
                                                    tmsPlanningMonth[idx].dateString,
                                                    'direct',
                                                    'tmsval'
                                                  ) !== '-'
                                                    ? '0.8'
                                                    : '0.4',
                                              }}
                                            />
                                          }
                                          disabled={
                                            getValues(
                                              directCOT.value,
                                              tmsPlanningMonth[idx].dateString,
                                              'direct',
                                              'tmsval'
                                            ) == '-'
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            handleCopyButtonClick(true, idx);
                                          }}
                                          rounded
                                          text
                                          aria-label="Filter"
                                        />
                                        {copyRowinfo.has(
                                          directCOT.value.toLowerCase() +
                                            tmsPlanningMonth[idx].dateString +
                                            'direct'
                                        ) ? (
                                          <Button
                                            style={{
                                              height: '28px',
                                              width: '28px',
                                            }}
                                            icon={
                                              <img
                                                src={ResetIcon}
                                                style={{
                                                  height: '20px',
                                                  width: '20px',
                                                  cursor: 'pointer',
                                                  opacity:
                                                    getValues(
                                                      directCOT.value,
                                                      tmsPlanningMonth[idx].dateString,
                                                      'direct',
                                                      'tmsval'
                                                    ) !== '-'
                                                      ? '0.8'
                                                      : '0.4',
                                                }}
                                              />
                                            }
                                            disabled={
                                              getValues(
                                                directCOT.value,
                                                tmsPlanningMonth[idx].dateString,
                                                'direct',
                                                'tmsval'
                                              ) == '-'
                                                ? true
                                                : false
                                            }
                                            onClick={() => {
                                              handleResetButtonClick(true, idx);
                                            }}
                                            rounded
                                            text
                                            aria-label="Filter"
                                          />
                                        ) : (
                                          <div style={{ width: '2rem' }}></div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className={classes.categoryButtonGroup}>
                      <Button
                        className={classes.saveBtnStyle}
                        onClick={() => {
                          setIsdirect(true);
                          setSingleConfirmVisibility(prev => !prev);
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        className={classes.finishBtnStyle}
                        onClick={() => {
                          setFinishConfirmVisibility(prev => !prev);
                          setIsDirectFinish(true);
                        }}
                      >
                        Finish
                      </Button>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
              {/* Direct Container end */}
              <hr />
              {/* Indirect Container start */}
              <div
                style={{
                  marginLeft: '0.5rem',
                  marginRight: '0.5rem',
                  marginTop: '0.5rem',
                }}
              >
                <Accordion className={classes.accordianComponent}>
                  <AccordionTab header="Indirect">
                    <div className={classes.directContainer}>
                      <div className={classes.topHeader}>
                        <div className={classes.saleDetails}>
                          <div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              YTD:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, 'YTD', 'indirect')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                            <div className={classes.vertical}></div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              3MA:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, '3MA', 'indirect')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                            <div className={classes.vertical}></div>
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              PM:
                              <span>
                                {!isSalesDetailsLoading ? (
                                  getSalesSummaryVal(directCOT.value, 'PM', 'indirect')
                                ) : (
                                  <ProgressSpinner
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration="1s"
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className={classes.directRadioGrp}>
                          <div>
                            <input
                              type="radio"
                              name="indirectRadio"
                              checked={indirectCOT.label === 'CMOP'}
                              onClick={() => {
                                setIndirectCOT(() => ({
                                  label: 'CMOP',
                                  value: 'CMOP',
                                }));
                              }}
                            />
                            <label htmlFor="cmop">CMOP</label>
                          </div>
                          <span>
                            <input
                              type="radio"
                              name="indirectRadio"
                              checked={indirectCOT.label === 'VA Facility'}
                              onClick={() => {
                                setIndirectCOT(() => ({
                                  label: 'VA Facility',
                                  value: 'VA Facility',
                                }));
                              }}
                            />
                            <label htmlFor="va">VA Facility</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="indirectRadio"
                              checked={indirectCOT.label === 'TMOP'}
                              onClick={() => {
                                setIndirectCOT(() => ({
                                  label: 'TMOP',
                                  value: 'TMOP',
                                }));
                              }}
                            />
                            <label htmlFor="tmop">TMOP</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="indirectRadio"
                              checked={indirectCOT.label === 'MTF'}
                              onClick={() => {
                                setIndirectCOT(() => ({
                                  label: 'MTF',
                                  value: 'MTF',
                                }));
                              }}
                            />
                            <label htmlFor="mtf">MTF</label>
                          </span>
                        </div>
                        <div>
                          {isOldValueCheckBoxVisible(directCOT.value, false) && (
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                paddingRight: '8px',
                                fontSize: '1rem',
                                gap: '1rem',
                              }}
                            >
                              New values
                              <InputSwitch
                                checked={isOldValuesCheckBoxChecked(false, directCOT.value)}
                                onChange={() => toggleOldValuesChekedSwitch(directCOT.value, false)}
                              />
                              Old values
                            </span>
                          )}
                        </div>
                      </div>

                      <div>
                        <div className={classes.planTable}>
                          <table>
                            <thead>
                              <th>
                                <td>Planning Period</td>
                              </th>
                              <th>
                                <td>Strat Code</td>
                              </th>
                              <th>
                                <td>TMS</td>
                              </th>
                              <th>
                                <td
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <span>MS Plan</span>
                                </td>
                              </th>
                              <th></th>
                            </thead>
                            <tbody>
                              {tmsPlanningMonth.map((_, idx) => {
                                const derampTitleIndirect = getIsDeramped(indirectCOT.value, tmsPlanningMonth[idx].dateString, 'indirect')
                                  ? `NC De-ramp applied — contract term date: ${tmsPlanningMonth[idx].dateString}`
                                  : undefined;
                                return (
                                  <tr
                                    key={idx}
                                    title={derampTitleIndirect}
                                    style={{
                                      backgroundColor: `${
                                        indirectFocused === idx ? '#f7f3fe' : ''
                                      }`,
                                    }}
                                  >
                                    <td>{tmsPlanningMonth[idx].label}</td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {getValues(
                                        indirectCOT.value,
                                        tmsPlanningMonth[idx].dateString,
                                        'indirect',
                                        'stratCode'
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {getValues(
                                        indirectCOT.value,
                                        tmsPlanningMonth[idx].dateString,
                                        'indirect',
                                        'tmsval'
                                      )}
                                    </td>

                                    <td style={{ fontWeight: '600' }}>
                                      <div className={classes.msPlanInputContainer}>
                                        <input
                                          id={`indirect-input-box-${idx}`}
                                          className={classes.msplanInp}
                                          value={getValues(
                                            indirectCOT.value,
                                            tmsPlanningMonth[idx].dateString,
                                            'indirect',
                                            'msplan'
                                          )}
                                          onChange={e => {
                                            updateMSPlanValue(
                                              e.target.value,
                                              indirectCOT.value,
                                              tmsPlanningMonth[idx].dateString,
                                              'indirect'
                                            );
                                          }}
                                          ref={(el: HTMLInputElement) =>
                                            (indirectInputFocus.current[idx] = el)
                                          }
                                          onKeyDown={e => handleIndirectKeyPress(e, idx)}
                                          onFocus={() => {
                                            handleIndirectFocus(idx);
                                          }}
                                          onBlur={() => {
                                            handleIndirectBlur();
                                          }}
                                        />{' '}
                                        <span> %</span>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <Button
                                          style={{
                                            height: '28px',
                                            width: '28px',
                                          }}
                                          icon={
                                            <img
                                              src={CopyIcon}
                                              style={{
                                                height: '20px',
                                                width: '20px',
                                                cursor: 'pointer',
                                                opacity: '0.8',
                                              }}
                                            />
                                          }
                                          disabled={
                                            getValues(
                                              indirectCOT.value,
                                              tmsPlanningMonth[idx].dateString,
                                              'indirect',
                                              'tmsval'
                                            ) == '-'
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            handleCopyButtonClick(false, idx);
                                          }}
                                          rounded
                                          text
                                          aria-label="Filter"
                                        />
                                        {copyRowinfo.has(
                                          indirectCOT.value.toLowerCase() +
                                            tmsPlanningMonth[idx].dateString +
                                            'indirect'
                                        ) ? (
                                          <Button
                                            style={{
                                              height: '28px',
                                              width: '28px',
                                            }}
                                            icon={
                                              <img
                                                src={ResetIcon}
                                                style={{
                                                  height: '20px',
                                                  width: '20px',
                                                  cursor: 'pointer',
                                                  opacity: '0.8',
                                                }}
                                              />
                                            }
                                            disabled={
                                              getValues(
                                                indirectCOT.value,
                                                tmsPlanningMonth[idx].dateString,
                                                'indirect',
                                                'tmsval'
                                              ) == '-'
                                                ? true
                                                : false
                                            }
                                            onClick={() => {
                                              handleResetButtonClick(false, idx);
                                            }}
                                            rounded
                                            text
                                            aria-label="Filter"
                                          />
                                        ) : (
                                          <div style={{ width: '2rem' }}></div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className={classes.categoryButtonGroup}>
                      <Button
                        className={classes.saveBtnStyle}
                        onClick={() => {
                          setIsdirect(false);
                          setSingleConfirmVisibility(prev => !prev);
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        className={classes.finishBtnStyle}
                        onClick={() => {
                          setFinishConfirmVisibility(prev => !prev);
                          setIsDirectFinish(false);
                        }}
                      >
                        Finish
                      </Button>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
              {/* Indirect Container end */}
              <div className={classes.bottomBtngroup}>
                <Button
                  style={{
                    backgroundColor: '#4D2E6D',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    border: 'none',
                  }}
                  onClick={() => setSummaryVisibility(prev => !prev)}
                >
                  Show Summary
                </Button>
                <div>
                  <Button
                    style={{
                      backgroundColor: '#D8000C',
                      color: '#FFFFFF',
                      fontWeight: 600,
                      border: 'none',
                    }}
                    onClick={handleNavigateToViewScreen}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{
                      backgroundColor: '#4D2E6D',
                      color: '#FFFFFF',
                      fontWeight: 600,
                      border: 'none',
                    }}
                    disabled={
                      !checkIfFunctionalityEnabled(
                        salesPlanAllowedRoles.createNewSalesPlan,
                        userModulesRoles.fdp,
                        userModulesRoles
                      )
                    }
                    onClick={() => setConfirmVisibility(prev => !prev)}
                  >
                    Finish All
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div className={classes.noDataContainer}>No TMS Edit data available!!</div>
          )}
        </div>
        {/* plan container end */}

        <div style={{ marginTop: '0.5rem' }}>
          <NotesSection
            mode="edit"
            isNotesDataLoading={
              isTMSNotesDataLoading || isConceptDetailsLoading || isConceptLoading
            }
            isNoteAddLoading={isMSplanNoteSaving}
            notesData={tmsNotesData}
            setNoteData={setNoteData}
            removeNoteData={removeNoteData}
            handleAddNote={handleNoteAdd}
            handleEditNote={handleEditNote}
            editLoading={isNoteEdited}
            handleDeleteNote={handleDeleteNote}
            deleteLoading={isNoteDeleted}
            isAddNewButtonDisabled={
              !checkIfFunctionalityEnabled(
                salesPlanAllowedRoles.createNewSalesPlan,
                userModulesRoles.fdp,
                userModulesRoles
              )
            }
          />
        </div>
      </div>

      {/* Finish modal start */}
      <ConfirmationModal
        visibility={finishConfirmVisibility}
        modalHeading=""
        modalContent={`Update MS plan for all COTs for ${
          isDirectFinish ? 'Direct' : 'Indirect'
        } with the provided values for concept - ${conceptDetails?.concept}`}
        confirmLabel="Update"
        handleCancel={() => setFinishConfirmVisibility(prev => !prev)}
        handleConfirm={() => setFinishPopup(prev => !prev)}
      />

      <ConfirmationModal
        visibility={finishPopup}
        modalHeading="Confirmation"
        modalContent={'Are you sure want to update?'}
        loading={savingCategory}
        confirmLabel="Yes"
        cancelLabel="No"
        handleCancel={() => {
          setFinishPopup(prev => !prev);
          setFinishConfirmVisibility(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleFinishforCategory(next);
          setFinishPopup(false);
          setFinishConfirmVisibility(false);
        }}
      />
      {/* Finish modal end */}

      {/* Finish all Modals start */}
      <ConfirmationModal
        visibility={confirmVisibility}
        modalHeading=""
        modalContent={`Update MS plan for all COTs with the provided values for concept - ${conceptDetails?.concept}`}
        confirmLabel="Update"
        handleCancel={() => setConfirmVisibility(prev => !prev)}
        handleConfirm={() => setConfirmPopup(prev => !prev)}
      />

      <ConfirmationModal
        visibility={confirmPopup}
        modalHeading="Confirmation"
        modalContent={'Are you sure want to update?'}
        loading={istmsUpdateLoading}
        confirmLabel="Yes"
        cancelLabel="No"
        handleCancel={() => {
          setConfirmPopup(prev => !prev);
          setConfirmVisibility(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleSaveAllCOTMSplan(next);
          setConfirmPopup(false);
          setConfirmVisibility(false);
        }}
      />
      {/* Finish all Modals end */}

      {/* Single Save modal start*/}
      <ConfirmationModal
        visibility={singleConfirmVisibility}
        modalHeading="Confirmation"
        modalContent={`Update MS plan for ${
          isDirect ? directCOT.label : indirectCOT.label
        } with the provided values?`}
        confirmLabel="Update"
        cancelLabel="Cancel"
        handleCancel={() => setSingleConfirmVisibility(prev => !prev)}
        handleConfirm={() => setSingleconfirmPopup(prev => !prev)}
      />

      <ConfirmationModal
        visibility={singleconfirmPopup}
        modalHeading="Confirmation"
        modalContent={'Are you sure want to update the Target Market Share Plan?'}
        confirmLabel="Yes"
        cancelLabel="No"
        loading={savingSingle}
        handleCancel={() => {
          setSingleConfirmVisibility(prev => !prev);
          setSingleconfirmPopup(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleSaveSingleCOTMSplan();
          setSingleConfirmVisibility(false);
          setSingleconfirmPopup(false);
        }}
      />
      {/* Single Save modal end*/}

      <SummaryModal
        visibility={summaryVisibility}
        toggleVisibility={() => setSummaryVisibility(prev => !prev)}
        planningMonths={tmsPlanningMonth}
        getValues={getValues}
      />
    </div>
  );
};

export default observer(TargetMarketPlanEdit);
